import styled from 'styled-components';

export const RadioButtonContainer = styled.label<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.s};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  user-select: none;
`;

export const OuterCircle = styled.div<{ checked: boolean; disabled?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ theme }) => theme.spacing.m};
  height: ${({ theme }) => theme.spacing.m};
  border: 1px solid
    ${({ theme, checked }) =>
      checked ? theme.colors.verdigris : theme.colorsInObjects.gray[700]};
  border-radius: 50%;
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
  transition:
    border-color 0.2s,
    opacity 0.2s;
`;

export const InnerCircle = styled.div<{ checked: boolean }>`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.verdigris};
  transition: opacity 0.2s;
  opacity: ${({ checked }) => (checked ? 1 : 0)};
`;

export const LabelText = styled.span<{ disabled?: boolean }>`
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
`;
